import type { ReactNode } from "react";

import styles from "./PanelRow.module.scss";

type PanelRowProps = {
  label: string;
  children?: ReactNode;
  testId?: string;
};

const isEmptyContent = (content: ReactNode) =>
  content === null || content === undefined || content === "";

/**
 * A label/value line inside a details panel card.
 *
 * Hiding on an empty label is not cosmetic: it is how an FI suppresses an individual
 * field, by setting that field's FTL string to the empty string. The per-account
 * sidebar this panel is at parity with does the same (`TransactionAttribute`).
 */
const PanelRow = ({ label, children, testId }: PanelRowProps) => {
  if (!label || isEmptyContent(children)) {
    return null;
  }

  const value =
    typeof children === "string" || typeof children === "number" ? (
      <span className={styles.value}>{children}</span>
    ) : (
      children
    );

  return (
    <div className={styles.row} data-testid={testId}>
      <span className={styles.label}>{label}</span>
      {value}
    </div>
  );
};

export default PanelRow;
